import { render, staticRenderFns } from "./updateCMSB.vue?vue&type=template&id=7564f73a&lang=pug&"
import script from "./updateCMSB.vue?vue&type=script&lang=js&"
export * from "./updateCMSB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports